// layered
import SugiyamaLayout from './SugiyamaLayout'

export default { SugiyamaLayout }
